import { fetchUserApi, deleteMultiUserApi, editUserApi } from "services/userService";
import { fetchUserDataSuccess, deleteUserSuccessMsg, setUserLoader, editAndDeleteUserErrorMsg, setPaginationCount, setPagination, editAndDeleteUserSuccessMsg, fetchSingleUserData, isDelete, isEdit } from "./reducer";
// import { fetchLocationDataSuccess } from "slices/auditeeLocation/reducer";

export const deleteMultiUser = (data: any) => async (dispatch: any) => {
  try {
    dispatch(setUserLoader(true));
    const response = await deleteMultiUserApi(data);

    if (response.success) {
      const message =
        data.status.toLowerCase() === "active"
          ? "User status changed to Active"
          : "User status changed to InActive";

      dispatch(deleteUserSuccessMsg({
        message,
        id: Date.now()
      }))
      dispatch(isDelete());

      // for current case as have total count in status = "", so solving auto count update with this
      const payload = {

        "user_id": 0,
        "phone_no": "",
        "status": "",
        "from_date": "",
        "to_date": "",
        "search_keyword": "",
        "is_verified": true,
        "page": 1,
        "page_size": 10

      }
      const response = await fetchUserApi(payload);
      if (response.success) {
        dispatch(setPaginationCount(response.data.pagination));
      }
    }


  } catch (blockUnblockError: any) {
    const errorMessage = blockUnblockError?.message || blockUnblockError?.response?.data?.message || "Something went wrong";
    dispatch(editAndDeleteUserErrorMsg(errorMessage));
    dispatch(setUserLoader(false));

  } finally {
    dispatch(setUserLoader(false));

  }
}

export const editUser = (data: any) => async (dispatch: any) => {
  try {
    dispatch(setUserLoader(true));
    const response = await editUserApi(data);
    if (response.success) {
      dispatch(editAndDeleteUserSuccessMsg({
        message: response.message || "Updated successfully",
        id: Date.now()
      }))
      dispatch(isEdit());
    }
  } catch (error) {
    dispatch(editAndDeleteUserErrorMsg(error || "Something went wrong"))
  } finally {
    dispatch(setUserLoader(false));
  }

}

export const fetchUserData = (data: any) => async (dispatch: any) => {
  // export const fetchUserData = (data: any, guid: string, selectedTab: string) => async (dispatch: any) => {
  dispatch(setUserLoader(true));
  try {
    const response = await fetchUserApi(data);
    if (response.success) {
      if (data.user_id != 0) {
        dispatch(fetchSingleUserData(response));

      }
      else if (data.status == "") {
        dispatch(setPaginationCount(response.data.pagination));
        dispatch(fetchUserDataSuccess(response));
        dispatch(setPagination(response.data.pagination));

      }
      else {
        dispatch(
          fetchUserDataSuccess(response)

        );
        dispatch(setPagination(response.data.pagination))
      }
      // dispatch(editAndDeleteUserSuccessMsg(response.message));
      // dispatch(editAndDeleteUserErrorMsg)
      // dispatch(setUserLoader(false));

    }
  } catch (fetchLocationError: any) {
    const errorMessage = fetchLocationError?.message || fetchLocationError?.response?.data?.message || "Something went wrong";
    dispatch(editAndDeleteUserErrorMsg(errorMessage));
  } finally {
  }
  dispatch(setUserLoader(false));
};

// export const fetchLocationData = (data: any, guid: string, selectedTab: string) => async (dispatch: any) => {
//   try {
//     dispatch(setLocationLoader(true));
//     const response = await fetchLocationsApi(data, guid, selectedTab);
//     // console.log(response);

//     if (response.success) {
//       dispatch(
//         fetchLocationDataSuccess(response)
//       );
//     }
//   } catch (fetchLocationError: any) {
//     const errorMessage = fetchLocationError?.message || fetchLocationError?.response?.data?.message || "Something went wrong";
//     dispatch(addLocationErrorMsg(errorMessage));
//   } finally {
//     dispatch(setLocationLoader(false));
//   }
// };

// export const fetchSingleLocationData =
//   (guid: string) => async (dispatch: any) => {
//     try {
//       const response = await fetchSingleLocationApi(guid);
//       if (response.success) {
//         dispatch(fetchSingleLocationDataSucess(response));
//       }
//     } catch (fetchLocationError: any) {
//       const errorMessage =
//         fetchLocationError?.message ||
//         fetchLocationError?.response?.data?.message ||
//         "Something went wrong";
//       // dispatch(addReportErrorMsg(errorMessage))
//     }
//     // finally {
//     //   dispatch(setLoaderFalse());
//     // }
//   };

// export const addLocation = (data: any, guid: string) => async (dispatch: any) => {
//   // console.log(data)
//   try {
//     const response = await addLocationApi(data, guid);


//     if (response.success) {
//       dispatch(
//         addLocationSuccess(response?.data)
//       );
//       dispatch(addLocationSuccessMsg(response?.message))
//     }
//   } catch (addLocationError: any) {
//     const errorMessage = addLocationError?.message || addLocationError?.response?.data?.message || "Something went wrong";
//     dispatch(addLocationErrorMsg(errorMessage));
//   } finally {
//     setTimeout(() => {
//         dispatch(reset_auditeeLocation_flag());
//       }, 5000);
//   }
// };


// export const editLocation = (data: any, id: number, guid: string) => async (dispatch: any) => {
//   try {
//     const params = { guid: id }
//     const response = await editLocationApi({ data, params }, guid);

//     if (response.success) {
//       dispatch(
//         editLocationSuccess(response?.data)
//       );
//       dispatch(editAndDeleteLocationSuccessMsg(response?.message))
//     }
//   } catch (addLocationError: any) {
//     const errorMessage = addLocationError?.message || addLocationError?.response?.data?.message || "Something went wrong";
//     dispatch(editAndDeleteLocationErrorMsg(errorMessage));
//   } finally {
//     setTimeout(() => {
//         dispatch(reset_auditeeLocation_flag());
//       }, 5000);
//   }
// };

// // export const deleteLocation = (data: any, id: number, guid: string) => async (dispatch: any) => {
// //   try {
// //     const params = { guid: id }
// //     const response = await deleteLocationApi({ data, params }, guid);

// //     if (response.success) {
// //       dispatch(
// //         deleteLocationSuccess(response?.data)
// //       );
// //       dispatch(editAndDeleteLocationSuccessMsg(response?.message))
// //     }
// //   } catch (addLocationError: any) {
// //     const errorMessage = addLocationError?.message || addLocationError?.response?.data?.message || "Something went wrong";
// //     dispatch(editAndDeleteLocationErrorMsg(errorMessage));
// //   } finally {
// //     setTimeout(() => {
// //         dispatch(reset_auditeeLocation_flag());
// //       }, 5000);
// //   }
// // };


// export const deleteMultipleLocations = (data: any,  guid: string) => async (dispatch: any) => {

//   try {

//     const response = await deleteMultipleLocationApi(data , guid);

//     const selectedIds = data?.identifiers;

//     if (response.success) {
//       dispatch(deleteMultipleLocationSuccess(selectedIds))
//       dispatch(editAndDeleteLocationSuccessMsg(response?.message))
//     }
//   } catch (deleteLocationError: any) {
//     const errorMessage = deleteLocationError?.message || deleteLocationError?.response?.data?.message || "Something went wrong";
//     dispatch(editAndDeleteLocationErrorMsg(errorMessage));
//   }
//   finally {
//     setTimeout(() => {
//         dispatch(reset_auditeeLocation_flag());
//       }, 5000);
//   }
// };












// fetchDistributorListSuccess



// export const exportAuditeLocationData =
//   (data: any, guid: string, payload:any) => async (dispatch: any) => {
//     try {
//       const payloadGuid = {
//         "guids":data
//       }
//       const response = await exportAuditLocationApi(payloadGuid, guid,payload);
//     } catch (exportReportError: any) {
//       const errorMessage =
//         exportReportError?.message ||
//         exportReportError?.response?.data?.message ||
//         "Something went wrong";
//     }
//   };